define("shared/components/shared/video-player", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/utils/canvas-video-player", "later/utils/object-promise-proxy", "shared/utils/constants/keys", "shared/utils/handle-key-up", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _canvasVideoPlayer, _objectPromiseProxy, _keys, _handleKeyUp, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/utils/canvas-video-player",0,"later/utils/object-promise-proxy",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-up",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! template-lint-disable no-invalid-interactive }}
  <div
    class={{@videoContainerClass}}
    ...attributes
    {{on "click" this.handleMediaClick}}
    {{did-insert this.handleInsert}}
    {{did-update this.handleUpdate @cropArray @trimArray @thumbOffset @postMediaItem}}
    {{did-update this.handleAudioMixUpdate @audioVolume @overlayAudioSrc @overlayAudioVolume @loopOverlayAudio}}
  >
    <video
      class="video u--hide"
      id={{this.videoId}}
      preload="metadata"
      {{on "loadedmetadata" (perform this.onLoadedMeta)}}
      {{on "seeked" (set this "isSeeking" false)}}
      {{on "seeking" (set this "isSeeking" true)}}
      {{on "timeupdate" this.handleTimeUpdate}}
    >
      <source src={{this.videoUrl}} type="video/mp4" />
    </video>
    {{#if @showProcessingImage}}
      <img
        alt=""
        class={{concat-classes
          this.canvasClass
          (if (or this.onLoadedMeta.last.isSuccessful this.showCustomCover) "u--hide")
        }}
        src={{@postMediaItem.processingImageUrl}}
      />
    {{/if}}
    <Shared::Image
      @picture={{hash alt="" sources=(if @customCoverPMI.previewUrl @customCoverPMI.previewUrl)}}
      class={{concat-classes this.canvasClass (unless this.showCustomCover "u--hide")}}
    />
    <canvas
      class={{concat-classes
        this.canvasClass
        (unless this.onLoadedMeta.last.isSuccessful "u--hide")
        (if this.showCustomCover "u--hide")
      }}
      id={{this.canvasId}}
    ></canvas>
  </div>
  {{! Playback Seekbar }}
  {{#if @timeline}}
    <div class="tMM--playback--sm eMM--playback" id={{this.timelineId}}>
      <div class="tMM--playback__progress eMM--playbackProgress"></div>
    </div>
  {{/if}}
  {{yield
    (hash
      controls=(component
        "shared/video-player/controls"
        playButtonId=this.playButtonId
        toggle=this.toggleVideo
        keyboardToggle=this.keyboardToggle
        play=this.playVideo
        pause=this.pauseVideo
      )
      isSeeking=this.isSeeking
    )
  }}
  */
  {
    "id": "FPblycdl",
    "block": "[[[11,0],[16,0,[30,1]],[17,2],[4,[38,0],[\"click\",[30,0,[\"handleMediaClick\"]]],null],[4,[38,1],[[30,0,[\"handleInsert\"]]],null],[4,[38,2],[[30,0,[\"handleUpdate\"]],[30,3],[30,4],[30,5],[30,6]],null],[4,[38,2],[[30,0,[\"handleAudioMixUpdate\"]],[30,7],[30,8],[30,9],[30,10]],null],[12],[1,\"\\n  \"],[11,\"video\"],[24,0,\"video u--hide\"],[16,1,[30,0,[\"videoId\"]]],[24,\"preload\",\"metadata\"],[4,[38,0],[\"loadedmetadata\",[28,[37,3],[[30,0,[\"onLoadedMeta\"]]],null]],null],[4,[38,0],[\"seeked\",[28,[37,4],[[30,0],\"isSeeking\",false],null]],null],[4,[38,0],[\"seeking\",[28,[37,4],[[30,0],\"isSeeking\",true],null]],null],[4,[38,0],[\"timeupdate\",[30,0,[\"handleTimeUpdate\"]]],null],[12],[1,\"\\n    \"],[10,\"source\"],[15,\"src\",[30,0,[\"videoUrl\"]]],[14,4,\"video/mp4\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,11],[[[1,\"    \"],[10,\"img\"],[14,\"alt\",\"\"],[15,0,[28,[37,6],[[30,0,[\"canvasClass\"]],[52,[28,[37,7],[[30,0,[\"onLoadedMeta\",\"last\",\"isSuccessful\"]],[30,0,[\"showCustomCover\"]]],null],\"u--hide\"]],null]],[15,\"src\",[30,6,[\"processingImageUrl\"]]],[12],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[8,[39,8],[[16,0,[28,[37,6],[[30,0,[\"canvasClass\"]],[52,[51,[30,0,[\"showCustomCover\"]]],\"u--hide\"]],null]]],[[\"@picture\"],[[28,[37,10],null,[[\"alt\",\"sources\"],[\"\",[52,[30,12,[\"previewUrl\"]],[30,12,[\"previewUrl\"]]]]]]]],null],[1,\"\\n  \"],[10,\"canvas\"],[15,0,[28,[37,6],[[30,0,[\"canvasClass\"]],[52,[51,[30,0,[\"onLoadedMeta\",\"last\",\"isSuccessful\"]]],\"u--hide\"],[52,[30,0,[\"showCustomCover\"]],\"u--hide\"]],null]],[15,1,[30,0,[\"canvasId\"]]],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,13],[[[1,\"  \"],[10,0],[14,0,\"tMM--playback--sm eMM--playback\"],[15,1,[30,0,[\"timelineId\"]]],[12],[1,\"\\n    \"],[10,0],[14,0,\"tMM--playback__progress eMM--playbackProgress\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[18,14,[[28,[37,10],null,[[\"controls\",\"isSeeking\"],[[50,\"shared/video-player/controls\",0,null,[[\"playButtonId\",\"toggle\",\"keyboardToggle\",\"play\",\"pause\"],[[30,0,[\"playButtonId\"]],[30,0,[\"toggleVideo\"]],[30,0,[\"keyboardToggle\"]],[30,0,[\"playVideo\"]],[30,0,[\"pauseVideo\"]]]]],[30,0,[\"isSeeking\"]]]]]]]],[\"@videoContainerClass\",\"&attrs\",\"@cropArray\",\"@trimArray\",\"@thumbOffset\",\"@postMediaItem\",\"@audioVolume\",\"@overlayAudioSrc\",\"@overlayAudioVolume\",\"@loopOverlayAudio\",\"@showProcessingImage\",\"@customCoverPMI\",\"@timeline\",\"&default\"],false,[\"on\",\"did-insert\",\"did-update\",\"perform\",\"set\",\"if\",\"concat-classes\",\"or\",\"shared/image\",\"unless\",\"hash\",\"yield\",\"component\"]]",
    "moduleName": "shared/components/shared/video-player.hbs",
    "isStrictMode": false
  });
  let VideoPlayerComponent = _exports.default = (_class = class VideoPlayerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "canvas", _descriptor2, this);
      _initializerDefineProperty(this, "video", _descriptor3, this);
      _initializerDefineProperty(this, "canvasVideoPlayer", _descriptor4, this);
      _initializerDefineProperty(this, "isLoaded", _descriptor5, this);
      _initializerDefineProperty(this, "isPlaying", _descriptor6, this);
      _initializerDefineProperty(this, "isSeeking", _descriptor7, this);
      _defineProperty(this, "onLoadedMeta", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          try {
            this.isLoaded = true;
            yield this._validateVideoDimensions.perform();
            this._createPlayer();
          } catch (adapterError) {
            this.errors.handleAdapter(adapterError, this.args.postMediaItem);
          }
        }
      }), null, "onLoadedMeta", null));
      _defineProperty(this, "_toggleVideo", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const delay = 250;
          yield (0, _emberConcurrency.timeout)(delay);
          this.canvasVideoPlayer?.playPause();
        }
      }), null, "_toggleVideo", "drop"));
      _defineProperty(this, "_validateVideoDimensions", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const {
            videoHeight,
            videoWidth
          } = this.video || {};
          if (!videoHeight || !videoWidth) {
            return;
          }
          const mediaItem = yield (0, _objectPromiseProxy.default)(this.mediaItem);
          if (videoHeight !== this.videoHeight || videoWidth !== this.videoWidth) {
            mediaItem.setProperties({
              width: videoWidth,
              height: videoHeight
            });
            return yield mediaItem.save();
          }
          return mediaItem;
        }
      }), null, "_validateVideoDimensions", null));
    }
    get mediaItem() {
      return this.args.postMediaItem.mediaItem;
    }
    get videoFrameRate() {
      return this.mediaItem.get('videoFrameRate') || undefined;
    }
    get videoHeight() {
      return this.args.postMediaItem.height || undefined;
    }
    get videoUrl() {
      return this.mediaItem.get('videoUrl') || undefined;
    }
    get videoWidth() {
      return this.args.postMediaItem.width || undefined;
    }
    get videoEndTime() {
      return this.args.postMediaItem.trimArray?.lastObject || this.args.postMediaItem.endTime || undefined;
    }
    get videoStartTime() {
      return this.args.postMediaItem.trimArray?.firstObject || this.args.postMediaItem.startTime;
    }
    get videoId() {
      return this.args.videoId ?? `eVP--video--${this.args.id}`;
    }
    get canvasId() {
      return this.args.canvasId ?? `preview-canvas--${this.args.id}`;
    }
    get canvasClass() {
      return this.args.canvasClass ?? 'canvas o--media';
    }
    get timelineId() {
      return this.args.timeline ? `playback--${this.args.id}` : undefined;
    }
    get playButtonId() {
      return `control__btn--${this.args.id}`;
    }
    get showCustomCover() {
      return Boolean(this.args.showCustomCover && this.args.customCoverPMI && !this.isPlaying);
    }
    get videoCoverTime() {
      const {
        thumbOffset,
        postMediaItem: {
          videoDuration
        }
      } = this.args;
      if (thumbOffset && videoDuration) {
        // The BE code moves the offset back by 500ms when the offset is set to the end of the video.
        if (Math.floor(videoDuration) < thumbOffset / 1000 + 0.5) {
          return videoDuration - 0.5;
        }
        return this.args.postMediaItem.startTime + thumbOffset / 1000;
      }
      return this.videoStartTime;
    }
    willDestroy() {
      super.willDestroy();
      if (this.canvasVideoPlayer) {
        if (this.canvasVideoPlayer.animationFrame) {
          cancelAnimationFrame(this.canvasVideoPlayer.animationFrame);
        }
        this.canvasVideoPlayer?.unbind?.();
      }
    }
    handleTimeUpdate(event) {
      this.args.videoTimeUpdate?.(event);
    }
    handleInsert() {
      this.video = document.getElementById(this.videoId);
      this.canvas = document.getElementById(this.canvasId);
    }
    handleUpdate() {
      this.video?.load();

      // Note: when changing media, cover time must be > 0 else the canvas is blank
      const canvasCoverTime = Math.max(this.videoCoverTime || 0, 0.1);
      if (this.canvasVideoPlayer) {
        const options = {
          cropArray: this.args.cropArray,
          startTime: this.videoStartTime,
          endTime: this.videoEndTime,
          coverTime: canvasCoverTime
        };
        this.canvasVideoPlayer.setup(options);
        this.canvasVideoPlayer.init();
      }
    }
    handleMediaClick() {
      return this.args.onMediaClick ? this.args.onMediaClick() : false;
    }
    handleAudioMixUpdate() {
      this.canvasVideoPlayer?.setAudioMix?.({
        audioVolume: this.args.audioVolume,
        overlayAudioSrc: this.args.overlayAudioSrc,
        overlayAudioVolume: this.args.overlayAudioVolume,
        loopOverlayAudio: this.args.loopOverlayAudio
      });
    }
    keyboardToggle(event) {
      (0, _handleKeyUp.default)(event, _keys.default.SPACE, () => {
        this._toggleVideo.perform();
      });
    }
    playVideo() {
      this.isPlaying = true;
      this.canvasVideoPlayer?.play();
    }
    pauseVideo() {
      this.isPlaying = false;
      this.canvasVideoPlayer?.pause();
    }
    toggleVideo() {
      this.isPlaying = !this.isPlaying;
      this._toggleVideo.perform();
    }
    _createPlayer() {
      if (this.canvas) {
        let width = 0;
        let height = 0;
        if (this.args.cropArray && this.args.cropArray.length) {
          const [x1, y1, x2, y2] = this.args.cropArray;
          width = x2 - x1;
          height = y2 - y1;
        } else {
          width = this.video?.videoWidth || 0;
          height = this.video?.videoHeight || 0;
          this.canvas.setAttribute('width', `${width}`);
          this.canvas.setAttribute('height', `${height}`);
        }
        this.canvasVideoPlayer?.unbind?.();
        const options = {
          videoSelector: `#${this.videoId}`,
          canvasSelector: `#${this.canvasId}`,
          timelineSelector: this.args.timeline ? `#${this.timelineId}` : false,
          playButtonSelector: `#${this.playButtonId}`,
          cropArray: this.args.cropArray,
          startTime: this.videoStartTime,
          endTime: this.videoEndTime,
          coverTime: this.videoCoverTime,
          audioVolume: this.args.audioVolume,
          overlayAudioSrc: this.args.overlayAudioSrc,
          overlayAudioVolume: this.args.overlayAudioVolume,
          loopOverlayAudio: this.args.loopOverlayAudio,
          onVideoEnd: this.args.handleVideoEnd
        };
        const player = new _canvasVideoPlayer.default(options);
        this.canvasVideoPlayer = player;
        if (!this.canvasVideoPlayer) {
          throw new Error('Video player canvas failed to initialize.');
        }
        this.canvasVideoPlayer?.setCanvasSize(width, height);
      }
    }
    _scaleWithBoxSizing(width, height) {
      let boxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      let boxHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 300;
      if (width > boxWidth || height > boxHeight) {
        const scaleX = boxWidth / width;
        const scaleY = boxHeight / height;
        return Math.min(scaleX, scaleY);
      }
      return 1;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "canvas", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "video", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canvasVideoPlayer", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isLoaded", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isPlaying", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isSeeking", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleTimeUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleTimeUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleInsert", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMediaClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMediaClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleAudioMixUpdate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleAudioMixUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyboardToggle", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "keyboardToggle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "playVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "playVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleVideo", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleVideo"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, VideoPlayerComponent);
});